import {AMBROSIA_URL} from '../../helpers/auth-header'
import Axios from 'axios'

export default {
    /**
     * First billing step, finding a CFDI from a given order number,
     * order date and its total
     *
     * @param commit
     * @param dispatch
     * @param e
     * @constructor
     */
    FindCFDI({commit, dispatch}, e){
        // -- Post data
        let postData = {
            'orderNumber': e.target.orderNumber.value,
            'date': e.target.date.value,
            'total': e.target.amount.value
        }

        // -- Sending request
        Axios.post(AMBROSIA_URL + '/billing/find-cfdi', postData )
        .then( response => {
            let isCFDICreated = response.data.data.cfdi !== null;

            commit('StateAssign', { 'billingOrder': response.data.data.order });
            commit('StateAssign', { 'billingCFDI': response.data.data.cfdi });
            commit('StateAssign', { 'billingExistingCFDI': isCFDICreated });
            commit('StateAssign', { 'billingStep': isCFDICreated ? 'billingDownloadStep' : 'billingInformationLookupStep' });
        })
        .catch( ex => {
            //TODO: Handle error
            dispatch('ShowToast', { 'icon':'error', 'title': 'Error', 'text': ex.response.data.errors });
        } )
    },

    /**
     * Fetches user given RFC from the server as well as the billing address and Order
     * If RFC does not exist, a new one is created.
     * If BillingEmail does not exist for a given RFC, it is created.
     *
     * @param commit
     * @param dispatch
     * @param state
     * @param e
     * @constructor
     */
    FetchBillingInformation({commit, dispatch, state}, e) {
        let email = e.target.email.value
        let rfcValue = e.target.rfc.value
        let legalName = e.target.legalName.value
        let orderNumber = state.billingOrder.number

        Axios.get(AMBROSIA_URL + `/billing/info?rfc=${rfcValue}&email=${email}&legalName=${legalName}&orderNumber=${orderNumber}`)
        .then( response => {
            commit('StateAssign', { billingRfc: response.data.data.rfc });
            commit('StateAssign', { billingEmail: response.data.data.billingEmail });
            commit('StateAssign', { billingStep: 'cfdiUseCaseStep' });
        })
        .catch( ex => {
            //TODO: Handle error
            dispatch('ShowToast', { 'icon':'error', 'title': 'Error', 'text': ex.response.data.errors });
        })
    },

    /**
     * Generates a new CFDI
     *
     * @param commit
     * @param dispatch
     * @param state
     * @constructor
     */
    async GenerateCFDI({commit, dispatch, state}){
        try{
            let postData = {
                'orderId': state.billingOrder.id,
                'cfdiUse': state.billingCFDIUseCase,
                'billingEmailId': state.billingEmail.id,
            }

            // -- Make CFDI generation request
            await Axios.post(AMBROSIA_URL + '/billing/create-cfdi', postData )
            commit('StateAssign', { billingStep: 'billingDownloadStep' })
        }catch ( ex ) {
            dispatch('ShowToast', { 'icon':'error', 'title': 'Error', 'text': ex.response.data.errors });
        }
    },

    /**
     * Sends the CFDI via Email
     *
     * @param commit
     * @param dispatch
     * @param state
     * @param e
     * @constructor
     */
    async RequestCFDIEmail({commit, dispatch, state}, e){
        try {
            let postData = {
                'orderId': state.billingOrder.id,
                'email': e.target.email.value
            }

            // -- Make CFDI generation request
            await Axios.post(AMBROSIA_URL + '/billing/send-cfdi-email', postData)
            commit('StateAssign', {billingStep: 'billingEmailSentStep'})
        }catch ( ex ) {
            dispatch('ShowToast', { 'icon':'error', 'title': 'Error', 'text': ex.response.data.errors });
        }
    },

    /**
     * Downloads a CFDI file from the server by given type and for a specific order
     * The downloaded file is saved by the browser storage
     *
     * @constructor
     */
    DownloadCFDI({dispatch}, e ){
        let orderId = e.target.dataset.order
        let downloadType = e.target.dataset.downloadType

        Axios.get(AMBROSIA_URL + `/billing/download?orderId=${orderId}&type=${downloadType}`,
        {
            responseType: 'arraybuffer',
            headers: {
                'Content-Type': 'application/json',
                'Accept': `application/${downloadType}`
            }
        })
        .then((response) => {
            const url = window.URL.createObjectURL(new Blob([response.data]));
            const link = document.createElement('a');
            link.href = url;
            link.setAttribute('download', `factura.${downloadType}`); //or any other extension
            document.body.appendChild(link);
            link.click();
        })
        .catch((ex) => {
            //TODO: Handle error
            dispatch('ShowToast', { 'icon':'error', 'title': 'Error', 'text': ex.response.data.errors });
        })
    }
}